import { createContext, useContext } from 'react';

import type { CollectionType } from 'bundles/enterprise-collections/components/CollectionItem';

export type EnterpriseCuratedCollectionsContextType = {
  curatedCollectionsLoading: boolean;
  curatedCollections?: CollectionType[];
  totalCuratedCollections?: number;
};

const EnterpriseCuratedCollectionsContext = createContext<EnterpriseCuratedCollectionsContextType>({
  curatedCollectionsLoading: false,
  curatedCollections: [],
  totalCuratedCollections: 0,
});

export const useCuratedCollections = () => useContext(EnterpriseCuratedCollectionsContext);

export default EnterpriseCuratedCollectionsContext;
